import { Subscription } from 'rxjs';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { CustomUtils } from '@app/shared/common';
import { AuthService } from '@app/core/authentication';

@Component({
  selector: 'app-form-factory',
  templateUrl: './form-factory.component.html',
  styles: [
    `
      ::ng-deep app-form-builder {
        width: 100%;
      }
    `,
  ],
})
export class FormFactoryComponent implements OnInit, OnDestroy {
  /**
   * @decription
   * Form builder is a component that works by passing it the json configuration
   * for the formand it itself creates the entire layout of the form and all the fields.
   * More about form builder system you can find here:
   * https://martinstefanovic.github.io/#/developer
   */

  /**
   * * General
   * @CustomUtils Global utility
   * @appConfig App config from ngrx store
   * @subscriptions Subscriptions array
   */
  CustomUtils = CustomUtils;
  appConfig: any;
  subscriptions: Subscription[] = [];
  /**
   * * Inputs
   * @form This is locale form for one language
   * @mainForm This is main FormGroup
   * @fields All form fields
   * @styleClass Css classes for main grid container
   * @multiLang Whether the form has multiple languages or not
   */
  @Input() form: FormGroup;
  @Input() mainForm: FormGroup;
  @Input() fields: any;
  @Input() styleClass: string;
  @Input() multiLang = false;
  curentUser;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private store: Store<{ config: any }>
  ) {
    /**
     * Get config from ngrx store
     */
    this.subscriptions.push(
      store.select('config').subscribe((res) => {
        this.appConfig = res;
      })
    );
  }

  /* ====================================
  *              LIFECYCLES
  ======================================= */

  ngOnInit(): void {
    this.curentUser = this.authService.userValue;
    this.fields = this.fields.filter(
      (field) =>
        field?.roles?.includes(this.curentUser.data.role) || !field?.roles
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }
}
